import { render, staticRenderFns } from "./AnchorPanel.vue?vue&type=template&id=5527f4b2&scoped=true"
import script from "./AnchorPanel.vue?vue&type=script&lang=js"
export * from "./AnchorPanel.vue?vue&type=script&lang=js"
import style0 from "./AnchorPanel.vue?vue&type=style&index=0&id=5527f4b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5527f4b2",
  null
  
)

export default component.exports